import { render, staticRenderFns } from "./SupervisorPhotoLightbox.vue?vue&type=template&id=6ba04074"
import script from "./SupervisorPhotoLightbox.vue?vue&type=script&lang=js"
export * from "./SupervisorPhotoLightbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports